import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background noise-bg p-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full border border-border bg-card p-8 text-center">
        <XCircle className="w-12 h-12 mx-auto text-muted-foreground" />
        <h1 className="font-display text-2xl font-black mt-4">Payment cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can renew anytime from Settings.</p>
        <Button className="rounded-none mt-6 w-full" onClick={() => navigate("/settings")} data-testid="cancel-settings-btn">Back to Settings</Button>
      </div>
    </div>
  );
}
